import { InviteCode, InviteCodeBase } from "../../types/inviteCode";
import { UserWorkspaceRole } from "../../userWorkspaceRoles";
import { WorkspaceMemberEntityAssignmentBase } from "../../types/workspace";
import { WorkspaceMemberEntityAssignmentDto } from "./workspace-member-entity-assignment.dto";

/**
 * Input type for WorkspaceInviteDto constructor.
 * Accepts Base type from entity classes - requires entityAssignments to be loaded
 * with entity.user for WorkspaceMemberEntityAssignmentDto.
 */
export type WorkspaceInviteDtoInput = Omit<
    InviteCodeBase,
    "entityAssignments"
> & {
    entityAssignments: WorkspaceMemberEntityAssignmentBase[];
};

export class WorkspaceInviteDto {
    static deserialize(dto: WorkspaceInviteDto): InviteCode {
        return {
            id: dto.id,
            email: dto.email,
            used: dto.used,
            entityAssignments: dto.entityAssignments.map(
                WorkspaceMemberEntityAssignmentDto.deserialize,
            ),
            role: dto.role,
            iconColor: dto.iconColor,
            inviteLink: dto.inviteLink,
            createdAt: dto.createdAt,
            updatedAt: dto.updatedAt,
        };
    }

    id: number;
    email: string | null;
    used: boolean;
    entityAssignments: WorkspaceMemberEntityAssignmentDto[];
    role: UserWorkspaceRole | null;
    iconColor: string;
    inviteLink: string;
    createdAt: Date;
    updatedAt: Date;

    constructor(invite: WorkspaceInviteDtoInput) {
        this.id = invite.id;
        this.email = invite.email;
        this.used = invite.used;
        this.entityAssignments = invite.entityAssignments.map(
            (ea) =>
                new WorkspaceMemberEntityAssignmentDto({
                    entity: ea.entity,
                }),
        );
        this.role = invite.role ?? null;
        this.iconColor = invite.iconColor;
        this.inviteLink = invite.inviteLink;
        this.createdAt = invite.createdAt;
        this.updatedAt = invite.updatedAt;
    }
}
